import React from "react";

function Location() {
  return (
    <div>
      <section class="text-gray-500 bg-gray-900 body-font relative">
        <div class="container px-5 py-24 mx-auto flex sm:flex-no-wrap flex-wrap">
          <div class="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
            <iframe
              width="100%"
              height="100%"
              title="map"
              class="absolute inset-0"
              frameborder="0"
              marginheight="0"
              marginwidth="0"
              scrolling="no"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d526.3994701046342!2d86.70377948683233!3d23.787217615005993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf3a06d76488561b2!2sSatimata%20STORE!5e0!3m2!1sen!2sin!4v1597595381030!5m2!1sen!2sin"
              //   style="filter: grayscale(1) contrast(1.2) opacity(0.16);"
            ></iframe>
            <div class="bg-gray-900 relative flex flex-wrap py-6">
              <div class="lg:w-1/2 px-6">
                <h2 class="title-font font-medium text-white tracking-widest text-sm">
                  ADDRESS
                </h2>
                <p class="leading-relaxed">
                  Manik Paul Satimata Store, Nirsa, Opposite of Nirsa Post
                  Office, Dist- Dhanbad, State- Jharkhand
                </p>
              </div>
              <div class="lg:w-1/2 px-6 mt-4 lg:mt-0">
                <h2 class="title-font font-medium text-white tracking-widest text-sm">
                  EMAIL
                </h2>
                <a class="text-purple-500 leading-relaxed">
                  maniksatimatastore@email.com
                </a>
                <h2 class="title-font font-medium text-white tracking-widest text-sm mt-4">
                  PHONE
                </h2>
                <p class="leading-relaxed">+919635352073</p>
              </div>
            </div>
          </div>
          <div
            class="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0"
            data-children-count="3"
          >
            <h2 class="text-white text-lg mb-1 font-medium title-font">
              Feedback
            </h2>
            <input
              class="bg-gray-800 rounded border border-gray-700 focus:outline-none focus:border-purple-500 text-base text-white px-4 py-2 mb-4"
              placeholder="Name"
              type="text"
              data-kwimpalastatus="alive"
              data-kwimpalaid="1593878988742-10"
            />
            <input
              class="bg-gray-800 rounded border border-gray-700 focus:outline-none focus:border-purple-500 text-base text-white px-4 py-2 mb-4"
              placeholder="Email"
              type="email"
              data-kwimpalastatus="alive"
              data-kwimpalaid="1593878988742-11"
            />
            <textarea
              class="bg-gray-800 rounded border border-gray-700 focus:outline-none h-32 focus:border-purple-500 text-base text-white px-4 py-2 mb-4 resize-none"
              placeholder="Message"
            ></textarea>
            <button class="text-white bg-purple-500 border-0 py-2 px-6 focus:outline-none hover:bg-purple-600 rounded text-lg">
              Send
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Location;
